export const REQUEST_ADD_TO_ACCOUNT_BALANCE = 'REQUEST_ADD_TO_ACCOUNT_BALANCE';
export const FINISH_ADD_TO_ACCOUNT_BALANCE = 'FINISH_ADD_TO_ACCOUNT_BALANCE';
export const SET_CURRENT_INVOICE_PAYMENT = 'SET_CURRENT_INVOICE_PAYMENT';
